import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  // Created fresh on every call: on HMR the old context module is disposed, so
  // reusing a hoisted reference would "require from a disposed module". A fresh
  // require.context resolves to the current (rebuilt) context module instead.
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const dateTimeFormats = {
  en: {
    dateTime: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric"
    }
  },
  lt: {
    dateTime: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric"
    }
  }
};

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "en",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  dateTimeFormats,
  messages: loadLocaleMessages()
});

// Dev-only: hot-swap locale strings into the live i18n instance when a JSON
// file under ./locales changes. Without this, the updated JSON module has no
// accepting parent, so webpack bubbles the update to the entry and resolves it
// with a full page reload — which fires Layout.vue's beforeunload guard
// ("Changes you made may not be saved") and drops reviewer state. Accepting the
// require.context module here stops the update at this boundary and re-applies
// the messages in place instead. Compiled out of the production build
// (module.hot is undefined there).
if (module.hot) {
  // Same (dir, recursive, regex) triple as loadLocaleMessages, so webpack
  // resolves it to the same context module — accepting its id catches a change
  // to any locale JSON and stops the update here instead of full-reloading.
  const localesContextId = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  ).id;
  module.hot.accept(localesContextId, () => {
    const messages = loadLocaleMessages();
    Object.keys(messages).forEach(locale => {
      i18n.setLocaleMessage(locale, messages[locale]);
    });
  });
}

export default i18n;
